<div class="flex">
  <div class="flex flex-wrap items-center gap-2">
    <button
      *ngFor="let item of items$ | async; trackBy: trackByItem; let i = index"
      mat-raised-button
      class="icon"
      [matTooltip]="item.name"
      (click)="addChartedItem(item)"
    >
      <div class="flex flex-col items-center justify-center">
        <mat-icon
          *ngIf="item.display?.icon.slug"
          [ngStyle]="{ color: item.display.colour.value }"
          [svgIcon]="item.display.icon.slug"
        />
        <span
          *ngIf="(hotkeyMap$ | async)?.[i] as hotkey"
          class="mat-caption hotkey-highlight"
        >
          {{ hotkey }}
        </span>
      </div>
    </button>
  </div>
</div>
